import UnknownRoute from "./UnknownRoute.js";
import InitialRoute from "./initialUrl/InitialRoute.js";
import UrlPathRoleCalculator from "./initialUrl/UrlPathRoleCalculator.js";
const install = molten => {
  molten.addPlugin('InitialUrlCalculator', {
    type: 'urlPathRoleCalculator',
    calculator: UrlPathRoleCalculator.calculator
  });
  molten.addPlugin('Route', InitialRoute.create(molten));
  molten.addPlugin('Route', UnknownRoute.create(molten));
};
export default {
  install
};